import React, { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import classNames from "classnames";
import * as c from "./scrollClipWrapper.module.scss";
import { BREAKPOINTS } from "@utils/breakpoints";

const ScrollClipWrapper = ({ children, className, style, gradientStart, gradientMiddle, gradientEnd }) => {
  const durations = [50, 25];
  const wrapperWidth = 1200;
  const container = useRef(null);
  const clipWrapperRef = useRef(null);

  // Combine custom gradient colors with any additional styles
  const wrapperStyle = {
    ...(gradientStart && { "--gradient-start": gradientStart }),
    ...(gradientMiddle && { "--gradient-middle": gradientMiddle }),
    ...(gradientEnd && { "--gradient-end": gradientEnd }),
    ...style,
  };

  useGSAP(
    () => {
      let mm = gsap.matchMedia();
      let calculatedWrapperWidth = wrapperWidth;
      let windowWidth = Math.max(
        (window.innerWidth - calculatedWrapperWidth) / 2,
        Math.min(window.innerWidth - calculatedWrapperWidth, 400)
      );

      const getBgWidth = () => {
        calculatedWrapperWidth = wrapperWidth;
        windowWidth = Math.max(
          (window.innerWidth - calculatedWrapperWidth) / 2,
          Math.min(window.innerWidth - calculatedWrapperWidth, 400)
        );
      };

      mm.add(`(min-width: ${BREAKPOINTS.xl}px)`, () => {
        window.addEventListener("resize", getBgWidth);
        gsap.set(clipWrapperRef.current, { "--clip-path": windowWidth + "px" });
        gsap
          .timeline({
            paused: false,
            scrollTrigger: {
              trigger: clipWrapperRef.current,
              start: () => "top 100%+=100px",
              end: () => "bottom 0%-=100px",
              invalidateOnRefresh: false,
              scrub: 1,
            },
          })
          .to(clipWrapperRef.current, { "--clip-path": "0px", duration: durations[0] })
          .to(clipWrapperRef.current, { "--clip-path": windowWidth / 1.618 + "px", duration: durations[1] }); // Golden ratio
      });

      return () => {
        window.removeEventListener("resize", getBgWidth);
      };
    },
    { scope: container, dependencies: [clipWrapperRef.current] }
  );

  return (
    <div ref={container} className={c.container}>
      <div ref={clipWrapperRef} className={classNames(c.clipWrapper, className)} style={wrapperStyle}>
        {children}
      </div>
    </div>
  );
};

export { ScrollClipWrapper };
